'use client';

import { useCallback } from 'react';
import { useComponentLogger } from '@/lib/component-logger';
import { CurValTable } from '../tables/curval-table';
import { Donut } from '../charts/donut';
import { Gauge } from '../charts/gauge';
import MyBar from '../charts/MyBar'
import { Image } from '../images/image';
import { ParagraphText } from '../typography/paragraph-text';
import { StatusText } from '../typography/status-text';
import { DynamicChart } from '../charts/DynamicChart';
import { Overlay } from '../overlay/overlay';
import { GoogleMap } from '../maps/google-map.jsx';

export function ProcessCardObject({cardObject, params={}, isLastObject, objectCount, isLoading=false, setIsLoading, selectable=false, onDeselectAll, onDeselectOne, onSelectAll, onSelectOne, selected=[], notifyParentLineCount, titleMinHeight, lineHeight}) {
    const logger = useComponentLogger("Process Card Object")
    if (!cardObject || cardObject.type === null || cardObject.type === undefined) return null;

    switch (cardObject?.type) {
        case "card":
            return <StatusText config={cardObject} notifyParentLineCount={notifyParentLineCount} titleMinHeight={titleMinHeight} lineHeight={lineHeight}/>
        case "donut":
            return <Donut config={cardObject}/>;
        case "gauge":
            return <Gauge config={cardObject} isLastObject={isLastObject} />
        case "image":
            return <Image config={cardObject} />
        case "table" :
            return <CurValTable config={cardObject} shouldOverrideTitle={objectCount === 1} selectable={selectable} onDeselectAll={onDeselectAll} onDeselectOne={onDeselectOne} onSelectAll={onSelectAll} onSelectOne={onSelectOne} selected={selected} />
        case "text":
            return <ParagraphText config={cardObject} />
        case "dynamicChart":
            return <DynamicChart config = {cardObject} chartParams={params} isLoading={isLoading} setIsLoading={setIsLoading} />
        case "bar":
            return <MyBar config = {cardObject}/>
        case "overlay":
            return <Overlay config={cardObject} />;
        case "map":
            return <GoogleMap config={cardObject} />
        // default:
        //     return <Text textObject={cardObject}/>
    }

}